import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { initApiResult, storedApiResult } from '../../modules/core/bffApiModule';
import * as CONSTANTS from '../../constants/constants';
import { isPrimeMenu } from "../../modules/core/menuModule";


export const BffApiResultHandler = () => {

  let history = useHistory();
  let location = useLocation();
  const dispatch = useDispatch();
  const apiResult = useSelector(storedApiResult);
  const isPrime = useSelector(isPrimeMenu);

  // ログイン時刻・曜日を取得
  // 念のため、UTC時間から+9時間した時刻・曜日を取得する
  const judgeLoginDateTime = () => {
    const now = new Date();
    // UTC時間に9時間（9 * 60 * 60 * 1000ミリ秒）を加算
    const loginTime = new Date(now.getTime() + 9 * 60 * 60 * 1000);
    let loginDayOfWeek = loginTime.getUTCDay();
    let loginHours = loginTime.getUTCHours();

    // スキルマップサービス稼働時間内かどうか判定　時間内ログイン：true、時間外ログイン：false
    return  CONSTANTS.SMS_START_HOUR <= loginHours && loginHours < CONSTANTS.SMS_END_HOUR && loginDayOfWeek > 0;
  }

  // 403エラー画面（元請・協力）遷移判定
  const judgePermissionErrorScreen = () => {
    if (isPrime) {
      return CONSTANTS.PATH_PRIME_PERMISSION_ERROR;
    } else {
      return CONSTANTS.PATH_PARTNER_PERMISSION_ERROR;
    }
  }

  // 503エラー画面（メンテナンス画面）遷移判定
  const judgeMainteScreen = () => {
    if (judgeLoginDateTime()) {
      // スキルマップ稼働時間内に503エラーが返された場合、緊急メンテナンスに遷移
      history.push(CONSTANTS.PATH_EMERGENCY_SYSTEM_MAINTENANCE);
      return <></>;
    } else {
      // スキルマップ稼働時間外に503エラーが返された場合、定期メンテナンスに遷移
      history.push(CONSTANTS.PATH_SYSTEM_MAINTENANCE);
      return <></>;
    }
  }

  useEffect(() => {
    switch (apiResult.status) {
      case CONSTANTS.API_STATUS_400:
        dispatch(initApiResult());
        history.push(CONSTANTS.PATH_SYSTEM_ERROR);
        break;
      case CONSTANTS.API_STATUS_401:
        dispatch(initApiResult());
        // シングルサインオン認証をスタートします。
        console.log(location.pathname);
        const host = window.location.host;
        // フロント側のドメインに合わせたBFFのURLを特定
        let baseURL;
        if (host.match("localhost")) {
          baseURL = CONSTANTS.BFF_SERVICE_ENDPOINT_FOR_LOCAL;
        } else if (host === 't2.skillmap-site.kensetsu-site.com') {
          baseURL = CONSTANTS.BFF_SERVICE_ENDPOINT_FOR_T2;
        } else if (host === 's2.skillmap-site.kensetsu-site.com') {
          baseURL = CONSTANTS.BFF_SERVICE_ENDPOINT_FOR_S2;
        } else if (host === 'skillmap-site.kensetsu-site.com') {
          baseURL = CONSTANTS.BFF_SERVICE_ENDPOINT_FOR_P2;
        }
        let authUrl: string = `${baseURL}/auth?next=`;
        authUrl += encodeURIComponent(window.location.href);
        window.location.assign(authUrl);
        break;
      case CONSTANTS.API_STATUS_403:
        dispatch(initApiResult());
        history.push(judgePermissionErrorScreen());
        break;
      case CONSTANTS.API_STATUS_500:
        dispatch(initApiResult());
        history.push(CONSTANTS.PATH_SYSTEM_ERROR);
        break;
      case CONSTANTS.API_STATUS_503:
        dispatch(initApiResult());
        judgeMainteScreen();
        break;
    }

  }, [apiResult]);

  return (
    <></>
  );
}
